<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<router-outlet></router-outlet>